

































import { snakeCase } from 'lodash'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import ConfigField from '../../ConfigField/ConfigField.vue'

@Component({
  components: {
    ConfigField,
  },
})
export default class FieldTitle extends Vue {
  @Prop() readonly titleKey!: string

  @Prop() readonly required!: string

  @Prop({ type: [ Object, Array ] }) readonly translationParams!:Array<any> | Record<string, any>

  get translations(): { [key: string]: any } {
    const formattedKey = snakeCase(this.titleKey)

    const transitions: { [key: string]: any } = {
      title: `field_${ formattedKey }_title`,
      help_message: `field_${ formattedKey }_help_message`,
      mini_help_message: `field_${ formattedKey }_mini_help_message`,
      info_message: `field_${ formattedKey }_info_message`,
    }

    for (const key of Object.keys(transitions)) {
      const value: string = transitions[key] as string

      if (key === 'title') {
        transitions[key] = this.$t(value, this.translationParams) as string
      } else {
        transitions[key] = this.$te(value) ? this.$t(value, this.translationParams) : '' as string
      }
    }

    return transitions
  }
}
